/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2026. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: OperatesToScopesEnum.ts
 * Created by: chan.ying
 * Create Date: 2026-07-31 16:01
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

export enum OperatesToScopesEnum {
    AddUser = 100,
    EditUser,
    DeleteUser,

    AddGroup,
    EditGroup,
    EditGroupMembership,
    DeleteGroup,

    ManageResourceSection
}